import React, { useState } from 'react';
import './MantraCategoryCard.css';

const MantraCategoryCard = ({ mantra, categoryId, onDelete, onEdit }) => {
    const [expanded, setExpanded] = useState(false);
    const [isEditing, setIsEditing] = useState(false);
    const [editName, setEditName] = useState(mantra.name);
    const [editText, setEditText] = useState(mantra.mantra_text);

    const formatDate = (dateString) => {
        if (!dateString) return 'Unknown date';
        const date = new Date(dateString);
        return date.toLocaleDateString('en-IN', {
            year: 'numeric',
            month: 'short',
            day: 'numeric',
        });
    };

    const truncateText = (text, maxLength = 150) => {
        if (!text) return '';
        if (text.length <= maxLength) return text;
        return text.substring(0, maxLength) + '...';
    };

    const handleEditClick = () => {
        setEditName(mantra.name);
        setEditText(mantra.mantra_text);
        setIsEditing(true);
    };

    const handleCancelEdit = () => {
        setIsEditing(false);
        setEditName(mantra.name);
        setEditText(mantra.mantra_text);
    };

    const handleSaveEdit = () => {
        if (onEdit) {
            onEdit(categoryId, mantra.name, editName, editText);
        }
        setIsEditing(false);
    };

    return (
        <>
            {/* Edit Modal */}
            {isEditing && (
                <div className="edit-modal-overlay" onClick={(e) => e.stopPropagation()}>
                    <div className="edit-modal">
                        <h2>✏️ Edit Mantra</h2>
                        <div className="edit-form">
                            <label>Name:</label>
                            <input
                                type="text"
                                value={editName}
                                onChange={(e) => setEditName(e.target.value)}
                            />
                            <label>Mantra Text:</label>
                            <textarea
                                value={editText}
                                onChange={(e) => setEditText(e.target.value)}
                                rows={10}
                            />
                            <div className="edit-modal-buttons">
                                <button className="save-button" onClick={handleSaveEdit}>💾 Save</button>
                                <button className="cancel-button" onClick={handleCancelEdit}>❌ Cancel</button>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            <div className="mantras-card">
                <div className="mantras-header">
                    <h5 className="mantras-title">{mantra.name}</h5>
                    <div className="mantras-actions">
                        <button
                            className="edit-mantras-btn"
                            onClick={handleEditClick}
                            title="Edit this mantra"
                        >
                            ✏️
                        </button>
                        <button
                            className="delete-mantras-btn"
                            onClick={() => onDelete(categoryId, mantra.name)}
                            title="Delete this mantra"
                        >
                            🗑️
                        </button>
                    </div>
                </div>

                <div className="mantras-content">
                    <div className="mantras-text">
                        {expanded ? (
                            <pre className="mantras-text-full">{mantra.mantra_text}</pre>
                        ) : (
                            <p className="mantras-text-preview">{truncateText(mantra.mantra_text)}</p>
                        )}
                    </div>

                    {mantra.mantra_text && mantra.mantra_text.length > 150 && (
                        <button className="expand-btn" onClick={() => setExpanded(!expanded)}>
                            {expanded ? '📖 Show Less' : '📜 Read Full'}
                        </button>
                    )}
                </div>

                <div className="mantras-footer">
                    <div className="mantras-meta">
                        <span className="mantras-date">📅 {formatDate(mantra.created_at)}</span>
                        <span className="mantras-length">📝 {mantra.mantra_text?.length || 0} chars</span>
                    </div>
                </div>
            </div>
        </>
    );
};

export default MantraCategoryCard;
